import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Layer_1"
      x={0}
      y={0}
      viewBox="0 0 21.9 25"
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {`.prefix__st0{fill:none;stroke:${props.color};stroke-linecap:round;stroke-linejoin:round}`}
      </style>
      <g id="prefix__Group_3051" transform="translate(-4423.5 -944.5)">
        <g id="prefix__Group_3050" transform="translate(4424 945)">
          <path
            id="prefix__Path_3996"
            className="prefix__st0"
            d="M17.6 3.3h3.3L17.6 0v3.3z"
          />
          <path
            id="prefix__Path_3997"
            className="prefix__st0"
            d="M17.6 0H0v24h20.9V3.3L17.6 0z"
          />
        </g>
        <path
          id="prefix__Path_3998"
          className="prefix__st0"
          d="M4436.1 948.8c0-1-.8-1.8-1.8-1.8s-1.8.8-1.8 1.8c-.2 1 .5 1.9 1.5 2.1 1 .2 1.9-.5 2.1-1.5v-.6z"
        />
        <path
          id="prefix__Path_3999"
          className="prefix__st0"
          d="M4432.1 950.9c-.8.4-1.4.9-1.4 1.6 0 1.1 1.6.7 3.6.7s3.6.4 3.6-.7c0-.6-.5-1.2-1.4-1.6"
        />
        <path
          id="prefix__Line_1048"
          className="prefix__st0"
          d="M4427.2 955.7h14.6"
        />
        <path
          id="prefix__Line_1049"
          className="prefix__st0"
          d="M4427 959h15.3"
        />
        <path
          id="prefix__Line_1050"
          className="prefix__st0"
          d="M4427 962.1h12.8"
        />
        <path
          id="prefix__Line_1051"
          className="prefix__st0"
          d="M4427.2 964.8h9.1"
        />
        <path
          id="prefix__Path_4000"
          className="prefix__st0"
          d="M4438.2 964.6l1.4 1.4 2.7-2.7"
        />
      </g>
    </svg>
  );
}

export default SvgComponent;
